export default {
  message: {
    "strid1": "ទំព័រដើម",
    "strid2": "ការបង្រៀន",
    "strid3": "ព្រឹត្តិការណ៍",
    "strid4": "ចូលរួម​ជាមួយ​យើង",
    "strid5": "Discord",
    "strid6": "Academy​ អ្នកបង្កើតមាតិកា",
    "strid7": "ស្នាដៃការងារដែលបានជ្រើសរើស",
    "strid8": "ថយក្រោយ",
    "strid9": "ចូលរួមឥឡូវនេះ",
    "strid10": "ព្រឹត្តិការណ៍ច្រើនទៀត",
    "strid11": "ព័ត៌មានផ្ទាល់ខ្លួន",
    "strid12": "Game Server",
    "strid13": "សូមបញ្ចូល Server របស់អ្នក",
    "strid14": "Game ID",
    "strid15": "សូមបញ្ចូល Game ID របស់អ្នក",
    "strid16": "ព័ត៌មានទំនាក់ទំនង",
    "strid17": "ជ្រើសរើសវេទិកា",
    "strid18": "សូមបញ្ចូលព័ត៌មានទំនាក់ទំនងរបស់អ្នក",
    "strid19": "ព័ត៌មានស្នាដៃការងារ",
    "strid20": "វេទិកាផ្សព្វផ្សាយ",
    "strid21": "សូមបញ្ចូល link ត្រឹមត្រូវ",
    "strid22": "ប៉ះដើម្បីបន្ថែម link ថ្មី",
    "strid23": "ភាសាដែលបានប្រើប្រាស់",
    "strid24": "ជ្រើសរើសភាសាដែលបានប្រើប្រាស់",
    "strid25": "អង់គ្លេស",
    "strid26": "អារ៉ាប់",
    "strid27": "អេស្ប៉ាញ",
    "strid28": "ព័រទុយហ្កាល់",
    "strid29": "ខេមរភាសា",
    "strid30": "ភូមា",
    "strid31": "ម៉ាឡេ",
    "strid32": "ផ្សេងទៀត",
    "strid33": "ខ្ញុំសូមបញ្ជាក់ពីភាពជាម្ចាស់នៃស្នាដៃការងារហើយទទួលស្គាល់កិច្ចព្រមព្រៀងនេះ",
    "strid34": "បញ្ជូន",
    "strid35": "បានបញ្ជូន",
    "strid36": "អត្ថប្រយោជន៍",
    "strid37": "ចូលរួមជាមួយពួកយើងឥឡូវនេះដើម្បីទទួលបាន",
    "strid38": "ការគាំទ្រពីបណ្តាញសង្គមផ្លូវការរបស់ MLBB",
    "strid39": "អ្នកបង្កើតសហគមន៍អន្តរកម្ម",
    "strid40": "រង្វាន់ពេជ្រប្រចាំសប្តាហ៍",
    "strid41": "អត្ថប្រយោជន៍ជាច្រើនបន្ថែមទៀត",
    "strid42": "ផលិតផលហ្គេម",
    "strid43": "ព្រឹត្តិការណ៍ក្រៅបណ្តាញ",
    "strid44": "ឈុតក្រៅជាច្រើន",
    "strid45": "Brand collaboration",
    "strid46": "ការផ្សព្វផ្សាយ",
    "strid47": "ចូលរួមជាមួយនឹងពួកយើង",
    "strid48": "តម្រូវការ",
    "strid49": "FOLLOW ពួកយើង",
    "strid50": "ប៉ះដើម្បីពិនិត្យមើលគណនីផ្លូវការរបស់ MLBB",
    "strid51": "មាតិកាកិច្ចព្រមព្រៀង",
    "strid52": "សូមបំពេញព័ត៌មាន",
    "strid53": "ការដាក់ស្នើបានបរាជ័យ",
    "strid54": "បំពេញតំណរភ្ជាប់ទៅកាន់ channel អ្នក",  // 请输入正确的频道链接
    "strid55": "ជ្រើសរើសតំបន់របស់អ្នក",
    "strid56": "តំបន់របស់អ្នក",


  }
}
